import { NgModule } from '@angular/core';
/* [GENERATED_IMPORTS_START] */
import { EeCoreWebappExtJsfModule } from './ext/ee-core-webapp-ext/jsf-module/ee-core-webapp-ext-jsf.module';
import { ExampleWebappExtJsfModule } from './ext/example-webapp-ext/jsf-module/example-webapp-ext-jsf.module';
/* [GENERATED_IMPORTS_STOP] */

/*
* THIS MODULE USING DURING COMPILE TIME TO GENERATE IMPORT FOR JSF MODULES.
*  Module should be located at src/ext/my-cool-ext/jsf-module/my-cool-ext-jsf.module
*  Where my-cool-ext-jsf.module is '<folder name>-jsf.module'.
*  And name of module should be MyCoolExtJsfModule, module name build from folder name too.
*/


@NgModule({
    imports: [
        /* [GENERATED_MODULES_IMPORTS_START] */
        EeCoreWebappExtJsfModule,
        ExampleWebappExtJsfModule
/* [GENERATED_MODULES_IMPORTS_STOP] */
    ]
})
export class XmJsfExtModule {
}
